import _classCallCheck from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { IS_PROXY } from 'proxy-state-tree';
import isPlainObject from 'is-plain-obj';
export function safeValue(value) {
  if (typeof value === 'function') {
    return '[Function]';
  }

  if (typeof value === 'object' && !Array.isArray(value) && value !== null && !isPlainObject(value)) {
    return "[".concat(value.constructor.name || 'NOT SERIALIZABLE', "]");
  }

  return value && !value[IS_PROXY] && isPlainObject(value) ? Object.keys(value).reduce(function (aggr, key) {
    aggr[key] = safeValue(value[key]);
    return aggr;
  }, {}) : value;
}
export function safeValues(values) {
  return values.map(safeValue);
}

var throttle = function throttle(func, limit) {
  var lastFunc;
  var lastRan;
  return function () {
    var context = this;
    var args = arguments;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

export var Devtools =
/*#__PURE__*/
function () {
  function Devtools(name) {
    var _this = this;

    _classCallCheck(this, Devtools);

    this.buffer = [];
    this.isConnected = false;
    this.doReconnect = false;
    this.hasWarnedReconnect = false;
    this.reconnectInterval = 10000;

    this.connect = function (host, onMessage) {
      host = host || 'localhost:3031';
      _this.ws = new WebSocket("ws://".concat(host));

      _this.ws.onmessage = function (event) {
        return onMessage(JSON.parse(event.data));
      };

      _this.ws.onopen = function () {
        _this.isConnected = true;

        _this.sendBuffer();
      };

      _this.ws.onerror = function () {};

      _this.ws.onclose = function () {
        _this.isConnected = false;

        if (_this.doReconnect && !_this.hasWarnedReconnect) {
          console.warn('Debugger application is not running on selected port... will reconnect automatically behind the scenes');
          _this.hasWarnedReconnect = true;
        }

        if (_this.doReconnect) {
          _this.reconnect(host, onMessage);
        }
      };
    };

    this.sendBuffer = throttle(function () {
      if (this.isConnected && this.buffer.length) {
        this.ws.send("{ \"appName\": \"".concat(this.name, "\", \"messages\": [").concat(this.buffer.join(','), "] }"));
        this.buffer.length = 0;
      }
    }, 50);
    this.name = name;
  }

  _createClass(Devtools, [{
    key: "reconnect",
    value: function reconnect(host, onMessage) {
      var _this2 = this;

      setTimeout(function () {
        return _this2.connect(host, onMessage);
      }, this.reconnectInterval);
    }
  }, {
    key: "send",
    value: function send(message) {
      var _this3 = this;

      var stringifiedMessage = JSON.stringify(message);
      (window['__zone_symbol__setTimeout'] || setTimeout)(function () {
        _this3.buffer.push(stringifiedMessage);

        _this3.sendBuffer();
      });
    }
  }]);

  return Devtools;
}();